"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactionLength = exports.isReachTransactionLimit = exports.getProvider = exports.getConnection = void 0;
const web3_js_1 = require("@solana/web3.js");
const anchor_1 = require("@project-serum/anchor");
let connection;
function getConnection(url) {
    if (connection) {
        return connection;
    }
    connection = new web3_js_1.Connection(url, {
        commitment: 'recent'
    });
    return connection;
}
exports.getConnection = getConnection;
let provider;
function getProvider(connection) {
    return __awaiter(this, void 0, void 0, function* () {
        if (provider) {
            return provider;
        }
        else {
            const wallet = window.solana;
            return provider = new anchor_1.Provider(connection, wallet, {
                commitment: 'recent'
            });
        }
    });
}
exports.getProvider = getProvider;
function isReachTransactionLimit(connection, user, instructions, signers) {
    return getTransactionLength(connection, user, instructions, signers) > 1232;
}
exports.isReachTransactionLimit = isReachTransactionLimit;
function getTransactionLength(connection, user, instructions, signers) {
    const transaction = new web3_js_1.Transaction();
    transaction.recentBlockhash = "8DCjq36FJve3BGPc5tu7emWCxG1deqPJzGdRBWTXeGqJ";
    transaction.feePayer = user;
    instructions.forEach((instruction) => transaction.add(instruction));
    return getTransactionLengthInner(transaction, signers);
}
exports.getTransactionLength = getTransactionLength;
function getTransactionLengthInner(transaction, signers) {
    return transaction.serializeMessage().length + signers.length * 64 + 65;
}
